/* RESPONSIBLE TEAM: team-ml */

import { default as OriginalRoute } from 'embercom/routes/apps/app/automation/workflows/edit';

export default class Route extends OriginalRoute {
  controllerName = 'apps/app/automation/workflows/edit';
}
